/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-10T11:30:43.722
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listContractSubjectManage,
	listContractSubjectManageInit,
	listContractSubjectManageByAuthorizations,
	deleteContractSubjectManage,
	authenticationSubject,
	telecom3FactorsBdhxMhxc2024,
	authenticationSubject2,
	sendFaceAuth
	
} from '@api/storagemanage/ContractSubjectManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listContractSubjectManage({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectManage(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listContractSubjectManageByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectManageByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listContractSubjectManageInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listContractSubjectManageInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteContractSubjectManage({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteContractSubjectManage({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		
		authenticationSubject({
			state
		}, data) {
			return new Promise((resolve, reject) => {
				authenticationSubject(data)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		
		authenticationSubject2({
			state
		}, data) {
			return new Promise((resolve, reject) => {
				authenticationSubject2(data)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		
		
		telecom3FactorsBdhxMhxc2024({
			state
		}, data) {
			return new Promise((resolve, reject) => {
				telecom3FactorsBdhxMhxc2024(data)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		
		
		sendFaceAuth({
			state
		}, subjectId) {
			return new Promise((resolve, reject) => {
				sendFaceAuth({
					subjectId :subjectId,
				})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
